import $ from "jquery";
// import Swiper JS
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

$('.size_guide_b2e7__slides').each(function(){

  var $slides = $(this);
  var $next = $slides.next();

  new Swiper($slides[0], {
    slidesPerView: 2,
    loop: true,
    breakpoints: {
      540: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        loop: false,
        slidesPerView: 6,
      },
    },
    navigation: {
      nextEl: $next[0],
    },
  
  });
});


function size_guide_hover() {
  if(window.innerWidth > 1024) {
    $('.size_guide_b2e7__size').on('mouseenter', function(){
      $('.size_guide_b2e7__size').removeClass('active');
      $(this).addClass('active');
    });
    
    $('.size_guide_b2e7__size').on('mouseleave', function(){
      $('.size_guide_b2e7__size').removeClass('active');
    });
  } else {
    $('.size_guide_b2e7__size').off('mouseenter');
    $('.size_guide_b2e7__size').off('mouseleave');
  }
}

$(window).on('resize', function() {
  size_guide_hover();
});

size_guide_hover();